import { connect } from 'react-redux';
import { Global } from '../../state/Global';
import GroupContactsToolbar from '../../components/Users/GroupContacts/GroupContactsToolbar';
import { actions as ModalActions } from '../../actions/modalActions';
import { ModalTypes } from 'constants/modalConstants';
import { selectSelection } from 'selectors/selectionSelectors';
import { handleExportGroupContactsToCsv } from 'utils/exportUtils';
import { actions as exportActions, ExportName } from 'actions/exportToCsvActions';
import { selectExportState } from '../../selectors/exportToCsvSelector';

const mapDispatchToProps = (dispatch: Function) => ({
  showAddUserModal: () => dispatch(ModalActions.openModal({ modalType: ModalTypes.ADD_GROUP_CONTACT })),
  showDeleteConfirmModal: () => dispatch(ModalActions.openModal({ modalType: ModalTypes.DELETE_GROUP_CONTACT })),
  handleExportData: async () => {
    dispatch(exportActions.doCsvExport(ExportName.GROUP_CONTACTS, handleExportGroupContactsToCsv));
  },
  resetExportState: () => {
    dispatch(exportActions.fetchCsvDataReset());
  }
});

const mapStateToProps = (state: Global) => {
  const selectionArray = selectSelection(state);
  const exportState = selectExportState(state);
  return {
    hasSelected: !!selectionArray.length,
    canDelete: !!selectionArray.length,
    isExporting: exportState.isBusy,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GroupContactsToolbar);
